import { useGameStore } from '../../stores/socketStore';
import { Tile } from './Tile';

export function Board() {
  const { gameState } = useGameStore();

  if (!gameState) return null;

  const { board } = gameState;
  const { width, height } = board.size;
  const boardAspectRatio = width / height;

  // Create grid of tiles
  const tiles: JSX.Element[] = [];
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const tileId = `${x},${y}`;
      const tile = board.tiles[tileId];
      tiles.push(<Tile key={tileId} position={{ x, y }} tile={tile} />);
    }
  }

  return (
    <div className="h-full rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
      <div
        className="mx-auto w-full"
        style={{
          width: `min(100%, calc((100vh - 220px) * ${boardAspectRatio}))`,
        }}
      >
        <div
          className="grid gap-1.5"
          style={{
            gridTemplateColumns: `repeat(${width}, minmax(0, 1fr))`,
          }}
        >
          {tiles}
        </div>
      </div>
    </div>
  );
}
